import template from '../../../templates/message-bar.html';

/* global angular, moment */

angular.module('atex.aceui.ui').component('messageBar', {
  bindings: {},
  controller: MessageBarController,
  template,
});

function MessageBarController($scope) {
  var ctrl = this;
  var errorTypeMap = {
    critical: 'danger',
    major: 'danger',
    minor: 'warning',
    minimal: 'warning'
  };

  ctrl.messages = [];

  $scope.$on('error:new', function (event, error) {
    var previous = ctrl.messages.length && ctrl.messages[ctrl.messages.length - 1],
      formattedTime = moment(error.date).format('LTS');

    if (previous && previous.alertClass === errorTypeMap[error.severity] && previous.value === error.cause) {
      previous.count++;
      previous.timestamp = formattedTime;
    } else {
      ctrl.messages.push({
        value: error.cause,
        alertClass: errorTypeMap[error.severity] || errorTypeMap['critical'],
        count: 1,
        timestamp: formattedTime,
        actions: error.action
      });
    }
  });

  $scope.$on('error:clear', function () {
    ctrl.messages = [];
  });

  ctrl.closeAlert = function (index) {
    ctrl.messages.splice(index, 1);
  };
}
